import { Copy, Mail, Phone } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "@/components/MaskedLines";

const EMAIL = "info@meranggi.com";
const PHONE_DISPLAY = "(0361) 943614";
const PHONE_TEL = "+62361943614";

const copy = async (value, label) => {
  try {
    await navigator.clipboard.writeText(value);
    toast.success(`${label} copied to clipboard`);
  } catch {
    toast.error("Could not copy — please copy manually");
  }
};

export const ContactSection = () => (
  <section id="contact" data-testid="contact-section" className="bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-5xl px-5 sm:px-6">
      <Reveal className="mx-auto max-w-3xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#86868b]">Contact</p>
        <h2
          data-testid="contact-heading"
          className="mt-4 text-3xl font-semibold leading-[1.12] tracking-tight text-[#1d1d1f] sm:text-4xl lg:text-5xl"
        >
          Get in touch with Meranggi.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-[#86868b]">
          No forms, no waiting queues. Write or call the workshop directly — tell us what you want to make.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2">
        <Reveal>
          <div className="flex h-full flex-col rounded-[28px] bg-[#f5f5f7] p-8 sm:p-10">
            <div className="flex items-center justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white">
                <Mail size={19} strokeWidth={1.75} className="text-[#1d1d1f]" />
              </span>
              <button
                data-testid="contact-copy-email-button"
                onClick={() => copy(EMAIL, "Email address")}
                aria-label="Copy email address"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#86868b] transition-colors duration-200 hover:text-[#0066cc]"
              >
                <Copy size={15} />
              </button>
            </div>
            <p className="mt-8 text-xs font-semibold uppercase tracking-[0.18em] text-[#86868b]">Email</p>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="contact-email-link"
              className="mt-2 text-2xl font-semibold tracking-tight text-[#0066cc] hover:underline sm:text-3xl"
            >
              {EMAIL}
            </a>
            <p className="mt-3 text-sm leading-relaxed text-[#86868b]">For production enquiries, quotations and sampling.</p>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="flex h-full flex-col rounded-[28px] bg-[#f5f5f7] p-8 sm:p-10">
            <div className="flex items-center justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white">
                <Phone size={19} strokeWidth={1.75} className="text-[#1d1d1f]" />
              </span>
              <button
                data-testid="contact-copy-phone-button"
                onClick={() => copy(PHONE_DISPLAY, "Phone number")}
                aria-label="Copy phone number"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#86868b] transition-colors duration-200 hover:text-[#0066cc]"
              >
                <Copy size={15} />
              </button>
            </div>
            <p className="mt-8 text-xs font-semibold uppercase tracking-[0.18em] text-[#86868b]">Telephone</p>
            <a
              href={`tel:${PHONE_TEL}`}
              data-testid="contact-phone-link"
              className="mt-2 text-2xl font-semibold tracking-tight text-[#0066cc] hover:underline sm:text-3xl"
            >
              {PHONE_DISPLAY}
            </a>
            <p className="mt-3 text-sm leading-relaxed text-[#86868b]">Bali landline (WITA) — the workshop office.</p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <p data-testid="contact-address-display" className="mt-10 text-center text-sm text-[#86868b]">
          CV Meranggi Jaya · Jl. Raya Udayana, Kecamatan Blahbatuh, Kabupaten Gianyar, Bali 80581, Indonesia
        </p>
      </Reveal>
    </div>
  </section>
);
